const bwodCardHeaderStyle = (theme) => ({
	headingWrapper: {
		background: (props) => props.background,
		display: 'flex',
		justifyContent : 'space-between'
	},
	heading: {
		padding: '10px',
		display: 'flex',
		alignItems: 'center'
	},
	discount: {
		height: '100px',
		width: '100px',
	},
});

export default bwodCardHeaderStyle;